import axios from 'axios';
import {
  getAuthorization,
  getAuthorization2FA,
  getAuthorizationPasswordChange,
} from 'utils/authCookie';
const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

async function request(path, method, { body, ...customConfig } = {}) {
  const token = Boolean(customConfig.passwordChange)
    ? getAuthorizationPasswordChange()
    : Boolean(customConfig.login2fa)
      ? getAuthorization2FA()
      : getAuthorization();

  const headers = { ...customConfig.headers };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (!headers['Content-Type'] && !(body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const config = {
    timeout: 30000,
    ...customConfig,
    method,
    url: BASE_URL + path,
    headers,
    data: body,
  };

  let response;
  try {
    response = await axios.request(config);
  } catch (e) {
    if (axios.isCancel(e) || e.name === 'AbortError') {
      throw e;
    }
    if (e.code === 'ECONNABORTED') {
      console.error('Request timed out');
      response = {
        status: 408,
        data: { message: 'Request timed out' },
      };
    } else {
      console.error(e);
      response = e.response || {
        status: 500,
        data: { message: e.message || 'Server Error' },
      };
    }
  }

  return response;
}

export async function get(path, config) {
  return request(path, 'GET', config);
}

export async function post(path, config) {
  return request(path, 'POST', config);
}

export async function put(path, config) {
  return request(path, 'PUT', config);
}

export async function patch(path, config) {
  return request(path, 'PATCH', config);
}

export async function del(path, config) {
  return request(path, 'DELETE', config);
}
